import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import classes from './ViewInfoButton.module.scss'
import ViewInfoModal from '../../shared/components/view-info-modal/ViewInfoModal'
import PmrE2EProjectOrderlineModel from '../../shared/interfaces/pmr-e2e-project-orderline-model'
import PmrE2EProjectFlexTaskMilestonesGroup from '../../shared/interfaces/pmr-e2e-project-milestone-group'

interface ViewInfoModalProps {
  data: PmrE2EProjectOrderlineModel | PmrE2EProjectFlexTaskMilestonesGroup
  rowIndex?: number
}

const ViewInfoButton = ({ data, rowIndex }: ViewInfoModalProps) => {
  const [tooltip, setTooltip] = useState('Model Details')
  const [showModelInfoModal, setShowModelInfoModal] = useState(false)

  const handleModelInfoModalIconClick = () => {
    setShowModelInfoModal(true)
  }

  const handleModelInfoModalClose = () => {
    setShowModelInfoModal(false)
  }

  return (
    <>
      <button onClick={handleModelInfoModalIconClick} className={classes['btn-view-icon']}>
        <FontAwesomeIcon title={tooltip} className={'gmawb-clickable-ui'} icon={faInfoCircle} />
      </button>

      <ViewInfoModal
        onHide={handleModelInfoModalClose}
        visible={showModelInfoModal}
        e2eprojectLineId={
          Array.isArray(data.e2EProjectLineId)
            ? data.e2EProjectLineId[rowIndex!]
            : data.e2EProjectLineId || ''
        }
      />
    </>
  )
}

export default ViewInfoButton
